module.exports = __webpack_public_path__ + "fonts/9879b67a18432f75223973f3f2a5d300.svg";